<div bsModal
     #rejectTimesheetModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg" style="max-width: 350px;">
        <div class="modal-content">
            <div class="modal-header no-border">
                {{ l('RejectReason')}}
            </div>
            <div class="modal-body no-border" style="padding-bottom: 0">
                <textarea class="reject-reason"
                          [(ngModel)]="rejectReason"></textarea>
                <p class="text-right pt-1" style="margin-bottom: 0">
                    <span [ngClass]="{'red': rejectReason.length > 160}"> {{ rejectReason.length }}</span> / 160
                </p>
            </div>

            <div class="modal-footer no-border">
                <button [disabled]="saving"
                        type="button"
                        class="btn btn-default"
                        (click)="close()">
                    {{l("Cancel")}}
                </button>

                <button (click)="save(rejectReason)"
                        [disabled]="!rejectReason || !rejectReason.length || rejectReason && rejectReason.length > 160"
                        class="btn btn-primary blue"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')">
                    <i class="fa fa-save"></i>
                    <span>
                      {{l("Reject")}}
                    </span>
                </button>
            </div>

        </div>
    </div>

</div>
